module.exports = __webpack_public_path__ + "img/network-backgtound-mobile.d246a341.svg";